/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  CRow,
  CCol,
  CCard,
  CCardHeader,
  CCardBody,
  CDataTable,
  CBadge,
  CPagination,
  CFormGroup,
  CLabel,
  CInput,
  CInputGroup,
  CInputGroupAppend,
  CInputGroupText,
  CButton,
  CSelect,
} from '@coreui/react';
import { CIcon } from '@coreui/icons-react';
import { freeSet } from '@coreui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Status from 'src/enums/Status';
import dayjs from 'dayjs';
import { deleteBranch, fetchBranchs } from 'src/slices/BranchSlice';
import { setItem } from 'src/slices/BranchItemSlice';
import { useTrans } from 'src/contexts/language';

const Branch = () => {
  const { t } = useTrans();
  const fields = [
    { key: 'name_vi', label: `${t('Tên tiếng')} ${t('Việt')}` },
    { key: 'status', label: t('Trạng thái') },
    { key: 'isMain', label: t('Chi nhánh chính') },
    { key: 'isHeadquarter', label: t('Headquarter') },
    { key: 'actions', label: t('Thao tác') },
  ];

  const branch = useSelector(state => state.branch);
  const branchItem = useSelector(state => state.branchItem);

  const dispatch = useDispatch();
  const history = useHistory();

  const getBadge = status => {
    switch (status) {
      case 1:
        return 'success';
      case 0:
        return 'danger';
      default:
        return 'primary';
    }
  };

  const handleDelete = item => {
    dispatch(deleteBranch({ ...item }));
  };

  const confirmDelete = item => {
    confirmAlert({
      title: t('Xác nhận xóa chi nhánh'),
      message: t('Chắc chắn muốn xóa chi nhánh này?'),
      buttons: [
        {
          label: 'Delete',
          className: 'bg-danger',
          onClick: () => {
            handleDelete(item);
          },
        },
        {
          label: 'Cancel',
          onClick: () => {},
        },
      ],
    });
  };

  const { entities, loading, currentPage, totalPage, total } = branch;
  const { status, search, date } = branchItem;

  useEffect(() => {
    dispatch(fetchBranchs({ page: currentPage, limit: 10 }));
  }, []);

  const handleSearch = () => {
    dispatch(
      fetchBranchs({ search, date: dayjs(date).format('YYYY-MM-DD'), status, page: 1, limit: 10 }),
    );
  };

  const setFilter = e => {
    const { name, value } = e.target;
    dispatch(setItem({ name, value }));
  };

  const navigateServiceDetail = id => {
    history.push(`branch/${id}`);
    // dispatch(
    //   NavigationActions.navigate({
    //     routeName: ,
    //   }),
    // );
  };

  return (
    <>
      <CCard>
        <CCardHeader>{t('Danh sách chi nhánh')}</CCardHeader>
        <CCardBody>
          <CRow>
            <CCol md="4">
              <CFormGroup>
                <CLabel htmlFor="search">{t('Tìm kiếm')}</CLabel>
                <CInputGroup>
                  <CInput
                    type="text"
                    id="search"
                    name="search"
                    placeholder={t('Nhập thông tin muốn tìm kiếm')}
                    autoComplete="off"
                    onChange={setFilter}
                  />
                  <CInputGroupAppend>
                    <CInputGroupText className="bg-info text-white">
                      <CIcon content={freeSet.cilSearch} />
                    </CInputGroupText>
                  </CInputGroupAppend>
                </CInputGroup>
              </CFormGroup>
            </CCol>

            <CCol md="4">
              <CFormGroup>
                <CLabel htmlFor="select_status">{t('Trạng thái')}</CLabel>
                <CSelect custom name="status" id="status" value={status || ''} onChange={setFilter}>
                  <option value="">{t('Tất cả')}</option>
                  {Object.keys(Status).map(key => (
                    <option value={Status[key].value}>{t(Status[key].name)}</option>
                  ))}
                </CSelect>
              </CFormGroup>
            </CCol>
          </CRow>
          <CRow>
            <CCol>
              <CButton
                className="mb-2 float-right"
                color="info"
                onClick={() => {
                  handleSearch();
                }}
              >
                {t('Tìm kiếm')}
              </CButton>
            </CCol>
          </CRow>
          <CRow>
            <CCol>
              <CCard>
                <CCardBody>
                  <CDataTable
                    items={entities}
                    fields={fields}
                    hover
                    striped
                    bordered
                    size="sm"
                    loading={loading === 'pending'}
                    itemsPerPage={10}
                    activePage={1}
                    scopedSlots={{
                      date: item => (
                        <td>{item.date && new Date(item.date).toLocaleDateString()}</td>
                      ),
                      status: item => (
                        <td>
                          <CBadge className="pointer" role="button" color={getBadge(item.status)}>
                            {item.status ? t('Hoạt động') : t('Không hoạt động')}
                          </CBadge>
                        </td>
                      ),
                      isMain: item => (
                        <td>
                          {!!item.isMain && (
                            <CBadge className="pointer" role="button" color={getBadge(item.isMain)}>
                              {t('Chính')}
                            </CBadge>
                          )}
                        </td>
                      ),
                      isHeadquarter: item => (
                        <td>
                          {!!item.isHeadquarter && (
                            <CBadge
                              className="pointer"
                              role="button"
                              color={getBadge(item.isHeadquarter)}
                            >
                              Headquarter
                            </CBadge>
                          )}
                        </td>
                      ),
                      actions: item => (
                        <td>
                          <span
                            onClick={() => {
                              navigateServiceDetail(item.id);
                            }}
                            className="pointer"
                            role="button"
                          >
                            <CIcon name="cilPencil" className="text-warning" />
                          </span>
                          <span className="ml-2" role="button" onClick={() => confirmDelete(item)}>
                            <CIcon name="cilTrash" className="text-danger" />
                          </span>
                        </td>
                      ),
                    }}
                  />
                  {total > 0 && (
                    <CRow>
                      <CCol>
                        <b>
                          {t('Tổng')}: {total}
                        </b>
                      </CCol>
                      <CCol className="text-right">
                        <CPagination
                          activePage={currentPage}
                          pages={totalPage}
                          onActivePageChange={page => dispatch(fetchBranchs({ page, limit: 10 }))}
                          align="end"
                        />
                      </CCol>
                    </CRow>
                  )}
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </>
  );
};

export default Branch;
